import Button from '@mui/material/Button';
import { styled } from '@mui/material';

export const StyledButton = styled(Button)(({ theme }) => ({
  color: theme.colors.alpha.black[100],
  background: theme.colors.gradients.primary,
  borderRadius: theme.spacing(3),
  padding: theme.spacing(1.5),
  border: 'none',
  transition: 'all ease',
  ':hover': {
    background: theme.bg.primaryDark
  },
  ':focus': {
    background: theme.bg.primaryDark,
    outline: '2px solid'
  },
  '&.Mui-disabled': {
    background: '#D1D1D0',
    color: theme.colors.alpha.black[75]
  }
}));

export const DeleteUserButton = styled(Button)(({ theme }) => ({
  // // TODO: add in root theme
  background: '#FFB09C',
  ':hover': {
    background: '#FF8A8A'
  },
  ':focus': {
    background: '#FF8A8A',
    outline: '2px solid'
  },
  color: theme.colors.alpha.black[100],
  transition: 'all ease'
}));

export const CancelDeleteUserButton = styled(Button)(({ theme }) => ({
  background: theme.bg.primary,
  ':hover': {
    background: theme.bg.primaryDark
  },
  ':focus': {
    background: theme.bg.primaryDark,
    outline: '2px solid'
  },
  color: theme.colors.alpha.black[100],
  '&.Mui-disabled': {
    background: '#D1D1D0',
    color: theme.colors.alpha.black[75]
  },
  transition: 'all ease'
}));
